import * as React from 'react';

export interface ScarcityMessageProps {
  scarcityMessage: string;
}

export const ScarcityMessage: React.FunctionComponent<ScarcityMessageProps> = ({ scarcityMessage }) => (
  <div className="uitk-cell all-y-padding-one pwa-theme--urgency uitk-type-right uitk-type-100">{scarcityMessage}</div>
);
